export function getRandomInt(min: number, max: number) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function getRandomIntForElementId() {
    let min = 0;
    let max = 999999999;
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function isNumberType(x: any): x is number {
    return typeof x === "number";
}

export function isNumber(x: any): x is number {
    return !isNaN(Number(x));
}